
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MenuItem } from 'primeng/api/menuitem';
import { PanelMenuModule } from 'primeng/panelmenu';
import { bmxurl } from 'src/globals';

import { Subject } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { DOCUMENT } from '@angular/common';
import { businessVenue } from 'src/types/businessVenues';
import { GlobalService } from './_services/global.service';
import { user } from 'src/types/users';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BusyService } from './_services/busy.service';
import { environment } from 'src/environments/environment';
import * as UAParser from 'ua-parser-js';
import { pinchange_returndata } from 'src/types/pinchange_returndata';
import { pinchange } from 'src/types/pinchange';
import { HelpKitReturn } from 'src/types/helpkit';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {

  httpResponse: any;
  loginDisplay = false;
  Venue: any;
  vsVenueName: string;
  currentUserName: string = '';
  auth0DisplayName: string = '';
  multiVenueUser: boolean;
  businessOwner: boolean;
  PasswordsMatch: boolean = true;
  showPasswordChange: boolean = false;
  OldPIN: string;
  NewPIN: string;
  RepeatNewPIN: string;

  idleState = "NOT_STARTED";
  countdown?: number = null;
  lastPing?: Date = null;
  ShowTimeOut: boolean = false;
  @Input() timeout: number = 600;
  bcitems: MenuItem[] = [];c
  home: MenuItem;
  ShowBC: boolean = false;
  MenuBuilder: [string, string];
  Users: user[];
  prodmode: boolean = false;
  version: string = environment.version;
  ShowChangePassword = false;
  BackendVersion: string = "";
  searchCriteria: string = "";
  UseCounters: boolean = false;

  EmailsRemaining: number = 0;
  showEmailWarning: boolean = false;

  SMSsRemaining: number = 0;
  showSMSWarning: boolean = false;

  showMenu: boolean = true;
  showHamburger: boolean = false;

  showSmallScreenHamburger: boolean = false;

  screenwidth: number = window.innerWidth;
  showSmallScreenMenu: boolean = false;
  kdsMode: boolean = false;
  tillMode: boolean = false;
  TillAccess: boolean = false;
  PaymentTypes: any[] = [];

  private readonly _destroying$ = new Subject<void>();
  private kitchenChannel = new BroadcastChannel('kitchen_updates');

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    public auth: AuthService,
    @Inject(DOCUMENT) private doc: Document,
    private globalService: GlobalService,
    private idle: Idle, 
    keepalive: Keepalive, 
    cd: ChangeDetectorRef,
    private busyService: BusyService
  ) 
  {

    addEventListener("resize", (event) => {
      this.screenwidth = window.innerWidth;
      this.updateMenuState();
    });

    this.updateMenuState();


      // Preserve device-local settings (per-venue till/terminal names, open tab options) across the
      // localStorage.clear() below. These are keyed by venueid suffix rather than a single known
      // "current" venue, since a shared/multi-venue device may hold saved values for several venues.
      const deviceLocalKeyPrefixes = ['TillName_', 'TerminalName_', 'GeneralTerminalName_', 'tabOptions_'];
      const deviceLocalKeys = Object.keys(localStorage).filter(k => deviceLocalKeyPrefixes.some(prefix => k.startsWith(prefix)));
      const savedDeviceLocalValues: Record<string, string> = {};
      deviceLocalKeys.forEach(k => { savedDeviceLocalValues[k] = localStorage.getItem(k)!; });

      localStorage.clear();

      deviceLocalKeys.forEach(k => localStorage.setItem(k, savedDeviceLocalValues[k]));

      if(localStorage.getItem("AllowTimeOut") != null)
      {
        if(localStorage.getItem("AllowTimeOut") == "true")
        {
          if(localStorage.getItem("idleTimeout") != null)
          {
            if(Number(localStorage.getItem("idleTimeout")) > 0)
            {
              this.timeout = Number(localStorage.getItem("idleTimeout"));
            }
          }
        }
      }

      this.timeout = 3600; // convert to seconds
      
      localStorage.getItem("AllowTimeOut") == "true" ? true : false
      //this.UseCounters = localStorage.getItem("UseCounter") == "true" ? true : false

      idle.setIdle(this.timeout); 
      idle.setTimeout(30); 
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); 

      idle.onIdleStart.subscribe(() => {
        if(router.url != "/pinpad" && router.url != "/" && router.url != "business")
          this.ShowTimeOut = true;
      });

      idle.onIdleEnd.subscribe(() => {
        this.ShowTimeOut = false;
        this.countdown = null;
        cd.detectChanges(); 
      });
      idle.onTimeout.subscribe(() => {
        this.ShowTimeOut = false;
        this.reset();
        //localStorage.setItem("SmartUserID",null);

        this.globalService.setShowPasswordChange(false);

        if(localStorage.getItem("businessowner") == "TRUE")
        {
          // PUT THIS BACK IN - localStorage.clear();
          auth.logout({ logoutParams: { returnTo: 'https://' + this.doc.location.host } });
        }
        else
        {
          this.router.navigateByUrl("/pinpad");
        }
      });

      idle.onTimeoutWarning.subscribe(seconds => this.countdown = seconds);

      keepalive.interval(15); 
  }

  items: MenuItem[];
  event: any;


  //Opens Venue Settings straight on its Settings tab rather than Venue Details. Gated only
  //by ShowBC, like the rest of the bar: the sidebar's Venue Settings entry has no access
  //gate either, and the page runs its own VENUESETTINGS check and says so if it fails.
  openVenueSettings() {
    this.router.navigate(['/venuesettings'], { queryParams: { tab: 'settings' } });
  }

  openTill() {
    this.router.navigateByUrl('/till');
    const el = this.doc.documentElement as any;
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    }
  }

  openKDS() {
    this.router.navigateByUrl('/kitchendisplaysystem');
    const el = this.doc.documentElement as any;
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    }
  }

  showHelp()
  {
    this.http.get<any>(bmxurl + "HelpKitUrl").subscribe(response => {
      const allowedOrigins = ['https://wannabook.online', 'https://help.wannabook.online', 'https://www.wannabook.online'];
      try {
        const parsed = new URL(response.data.url);
        if (allowedOrigins.includes(parsed.origin)) {
          window.open(response.data.url, "_blank");
        } else {
          this.messageService.add({severity:'error', summary:'Failure', detail: 'Help URL is not from a trusted source'});
        }
      } catch {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to get help'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to get help'});
    })
  }

  doEmail(){
    let mailText = "mailto:enquiries@smart-entertainment.co.uk?subject=New WannaBook Enquiry";
    window.location.href = mailText;
  }

  checkEmails()
  {
    //check emails remaining
    this.EmailsRemaining = 144;
    this.showEmailWarning = this.EmailsRemaining < 150 ? true : false;
  }

  displayMenu(){

    this.globalService.showSmallScreenMenu$.subscribe((value) => {
      this.showSmallScreenMenu = value;
    });

    
    //this.showSmallScreenMenu = !this.showSmallScreenMenu;
    this.globalService.setSmallScreenMenu(true);
  }

  checkSMSs()
  {
    //check emails remaining
    this.SMSsRemaining = 37;
    this.showSMSWarning = this.SMSsRemaining < 150 ? true : false;
  }

  buyMoreSMSs(){
    this.router.navigateByUrl("/subscriptions");
  }

  buyMoreEmails(){
    this.router.navigateByUrl("/subscriptions");
  }

  logout(){
    //ask for confirmation
    if (confirm("Are you sure you want to log out?")) { 
      this.auth.logout({ logoutParams: { returnTo: 'https://' + this.doc.location.host } })
    }
  }

  private getDeviceType(): string {
    const parser = new (UAParser as any)();
    return parser.getDevice().type ?? 'desktop';
  }

  private adjustViewportForTablet(): void {
    const contentWidth = 1280;
    const deviceWidth = window.innerWidth;
    if (deviceWidth < contentWidth) {
      const scale = (deviceWidth / contentWidth).toFixed(3);
      const meta = this.doc.querySelector('meta[name="viewport"]') as HTMLMetaElement;
      if (meta) {
        meta.content = `width=${contentWidth}, initial-scale=${scale}, minimum-scale=0.1, maximum-scale=5, user-scalable=yes`;
      }
    }
  }

  private updateMenuState(): void {
    const deviceType = this.getDeviceType();
    const isMobileOrTablet = deviceType === 'mobile' || deviceType === 'tablet';
    const smallScreen = this.screenwidth <= 900;

    if (isMobileOrTablet || smallScreen) {
      this.showMenu = false;
      this.showHamburger = false;
      this.showSmallScreenHamburger = true;

      if (deviceType === 'tablet') {
        this.adjustViewportForTablet();
      }
    } else {
      this.showMenu = true;
      this.showHamburger = true;
      this.showSmallScreenHamburger = false;
    }
  }

  get welcomeName(): string {
    //The stored name is filtered too, not just the one held in memory: a browser that went
    //through the old code still has the placeholder sat in local storage.
    const storedVenueName = localStorage.getItem('SmartVenueName') || '';
    const venueName = this.vsVenueName || (this.globalService.isRealVenueName(storedVenueName) ? storedVenueName : '');
    const userName = localStorage.getItem('SmartUserName') || this.auth0DisplayName || '';
    if (venueName && userName) return `${venueName} - ${userName}`;
    return venueName || userName;
  }

  resolveCurrentUserName(): void {
    const stored = localStorage.getItem('SmartUserName');
    if (stored && stored.trim()) {
      this.currentUserName = stored.trim();
      return;
    }
    const userId = localStorage.getItem('SmartUserID');
    const usersJson = localStorage.getItem('SmartUsers');
    if (!userId || !usersJson) {
      this.currentUserName = '';
      return;
    }
    try {
      const users: any[] = JSON.parse(usersJson);
      const match = users.find(u => String(u.userid) === String(userId));
      this.currentUserName = match?.name ?? '';
    } catch {
      this.currentUserName = '';
    }
  }

  logEntry(inText: string){
    // this.http.get(bmxurl + "/log?message=" + inText).subscribe(response => {
    //   this.httpResponse = response
    //   if (this.httpResponse.succeeded)
    //   {

    //   }
    //   else
    //   {
    //     this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Version Number'});
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Version Number, error:' + error.messages[0]});
    // });

  }

  ngOnInit(): void {

    this.auth.user$.subscribe(user => {
      if (user) {
        this.auth0DisplayName = user.name || user.email || '';
      }
    });

     //Get Payment Types

    this.http.get(bmxurl + "paymenttypes").subscribe(response => {
      if((response as paymenttypes_returndata).succeeded)
      {
        this.PaymentTypes = (response as paymenttypes_returndata).data;

        this.PaymentTypes = this.PaymentTypes.filter(pt => pt.system == false);

        localStorage.setItem("PaymentTypes", JSON.stringify(this.PaymentTypes));
      }
      else
      {
        //this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
      }
    }, error => {
      //this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })

    this.globalService.setSmallScreenMenu(false);

    this.logEntry("App Started");

    this.globalService.ShowPasswordChange.subscribe((value) => {
      this.ShowChangePassword = value;
    });

    if (environment.production) {
      this.prodmode = true;
    }
    else
    {
      this.prodmode = false;
    }

    //get version
    if (environment.production) {
      this.http.get(bmxurl + "/version").subscribe(response => {
        this.httpResponse = response
        if (this.httpResponse.succeeded)
        {
          this.logEntry("Version Check: " + this.httpResponse.data.version);
          if(this.version != this.httpResponse.data.version)
          {
            alert("This isn't the latest version, automatically getting latest version, please wait!");
            location.reload();  
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Version Number'});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Version Number, error:' + error.messages[0]});
      });
    }

    this.kitchenChannel.onmessage = (event) => {
      if (event.data?.type !== 'order_complete') return;
      if (this.kdsMode || this.tillMode) return;
      const table = event.data.tableNumber ? ` · Table ${event.data.tableNumber}` : '';
      this.messageService.add({
        severity: 'success',
        summary: 'Order Ready',
        detail: `Order ${event.data.name}${table} is ready for collection`,
        sticky: true
      });
    };

    localStorage.removeItem("SmartVenueID");
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {

        this.kdsMode = item.urlAfterRedirects.startsWith('/kitchendisplaysystem');
        this.tillMode = item.urlAfterRedirects.startsWith('/till') && !item.urlAfterRedirects.startsWith('/tilldep') && !item.urlAfterRedirects.startsWith('/tillprod') && !item.urlAfterRedirects.startsWith('/tillsale');
        this.TillAccess = localStorage.getItem('TillAccess') === 'true';
        this.resolveCurrentUserName();

        if(this.router.url != "/pinpad" && this.router.url != "/" && this.router.url != "/business")
        {
          this.ShowBC = true;
        }
        else
        {
          this.ShowBC = false;
        }
      }
    });

    this.logEntry("Built Navigation");

    this.home = {icon: 'pi home'};

    const head = document.getElementsByTagName('head')[0];

    const script = document.createElement('script');

    head.insertBefore(script, head.firstChild);
    //#region 
    let AccessControl = "";
    this.auth.isAuthenticated$.subscribe((authed) => {
      if(authed)
      {
        this.auth.getAccessTokenSilently().subscribe(token => {
          const parts = token.split('.');
          const decoded = JSON.parse(atob(parts[1]));

          this.logEntry("Business ID: " + decoded["user.metadata"].businessid);
          this.logEntry("Business User ID: " + decoded["user.metadata"].businessuserid);
          this.logEntry("Venue Name: " + decoded["user.metadata"].venuename);
          this.logEntry("Business Owner: " + decoded["user.metadata"].businessowner);
          this.logEntry("Multi-venue User: " + decoded["user.metadata"].multivenueuser);
          
          let BusinessID = decoded["user.metadata"].businessid;
          let VenueID = decoded["user.metadata"].vid;
          //let VenueID = localStorage.getItem("SmartVenueID")!;

          localStorage.setItem("SmartVenueID", VenueID);

          AccessControl  = decoded["user.metadata"].accesscontrol;
          let userid = decoded["user.metadata"].businessuserid;
          let venuename = decoded["user.metadata"].venuename;
          let businessid = decoded["user.metadata"].businessid;
          let multivenueuser = decoded["user.metadata"].multivenueuser;
          let businessuserid = decoded["user.metadata"].businessuserid;

          //Only trust the claim when it names a real venue, so it never clobbers the venue
          //actively selected via business.component's enterVenue() on a token refresh.
          let isRealVenueName = this.globalService.isRealVenueName(venuename);

          if (isRealVenueName) {
            this.globalService.setVenueName (venuename);
          }

          localStorage.setItem("SmartUserID", userid);
          localStorage.setItem("SmartBusinessID", businessid);

          if (isRealVenueName) {
            localStorage.setItem("SmartVenueName", venuename);
          }

          // let users: user[] =  (decoded["app.users"] as user[]);
          // let venues: businessVenue[] = (decoded["app.venues"] as businessVenue[]);

          let businessowner = decoded["user.metadata"].businessowner;
          if(businessowner == "true")
          {
            localStorage.setItem("businessowner", "TRUE");
            this.businessOwner = true;
          }
          else
          {
            localStorage.setItem("businessowner", "FALSE");
            this.businessOwner = false;
          }
          
          //get businesses from get
          this.http.get<any>(bmxurl + "business/" + businessid + '/' + businessuserid + '/' + VenueID + '/' + businessowner ).subscribe(response => {

          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            let users: user[] =  (this.httpResponse.data.users as user[]);
            let venues: businessVenue[] = (this.httpResponse.data.venues as businessVenue[]);

            if(multivenueuser == "true")
            {
              localStorage.setItem("SmartMultiVenueUser", "TRUE");
              this.multiVenueUser = true;
            }
            else
            {
              localStorage.setItem("SmartMultiVenueUser", "FALSE");
              this.multiVenueUser = false;
            }

            localStorage.setItem("SmartBusinessVenues", JSON.stringify(venues ?? []));
            localStorage.setItem("SmartUsers", JSON.stringify(users ?? []));
            this.resolveCurrentUserName();

            if((BusinessID != null || BusinessID != "") && VenueID == null) 
            {

              if(this.businessOwner)
              {
                this.logEntry("Business Owner so create menu");

                localStorage.setItem("SmartBusinessID", BusinessID);
                this.items = [{
                  label: 'BUSINESS',
                  items: [
                    {label: 'Business', icon: 'pi globe', routerLink: ['/business'], visible: true},
                    ]
                }];

                
                this.router.navigateByUrl("/business");
              }
              else
              {

                this.logEntry("Non-Business Owner so go to pinpad");

                localStorage.setItem("SmartBusinessID", BusinessID);
                this.items = [{
                  label: '',
                  items: [
                  
                    ]
                }];

                this.globalService.setMenuItems(this.items);

                this.router.navigateByUrl("pinpad");
              }

            }
            else
              {

                localStorage.setItem("SmartBusinessID", BusinessID);
                this.items = [{
                  label: '',
                  items: []
                }];

                this.globalService.setMenuItems(this.items);

                this.router.navigateByUrl("pinpad");
            }
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to businesses'});
          })
        });
      }

      this.globalService.menuItems$.subscribe((value) => {
        this.items = value;
      });


      this.globalService.menuBCItem$.subscribe((value) => {
        
        let newitems = [{
          label: '',
          items: []
        }];

        newitems[0].items.push(value);

        this.bcitems = newitems;
      });

      this.globalService.venueName$.subscribe((value) => {
        if(!value || value.toString() == '[object Object]' || value.toString().trim().toLowerCase() == 'not assigned')
        {
          this.vsVenueName = "";
        }
        else
        {
          this.vsVenueName = value;
        }
      });

      this.globalService.currentUserName$.subscribe((value) => {
        if (value) {
          this.currentUserName = value;
        } else {
          this.resolveCurrentUserName();
        }
      });

      this.globalService.useCounters$.subscribe((value) => {
        this.UseCounters = value;
      });


      this.http.get(bmxurl + "v").subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded){
          this.BackendVersion = this.httpResponse.data.version;
        }
        else{
          //this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting version, error: ' + this.httpResponse.messages[0]});
        }

      }, error => {
        //this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting version, error: ' + error.messages});
      });

      this.reset();
      });

      // if(this.businessOwner)
      // {
      //   this.router.navigateByUrl("/homepagechoice");
      // }

  }

  //% is a wildcard in the search the API runs, so one typed into the box matches everything and
  //drags back the whole table. Taken out as it is typed, which also covers a paste.
  searchCriteriaChanged() {
    if(this.searchCriteria != null && this.searchCriteria.indexOf("%") > -1)
    {
      this.searchCriteria = this.searchCriteria.replace(/%/g, "");
    }
  }

  getSearchResults(){
    if(this.searchCriteria != "")
    {
      localStorage.removeItem("SearchResults");
      let crit = this.searchCriteria;

      crit = crit.trim();

      //Belt and braces - nothing should reach here with one in it, but a wildcard must never
      //get as far as the API whatever route the text took to the box.
      crit = crit.replace(/%/g, "");

      if(crit == "")
      {
        return;
      }

      crit = crit.replace("/","-").replace("/","-");
      crit = encodeURIComponent(crit);

      this.searchCriteria = "";
      this.router.navigate(
        ['/search'],
        { queryParams: { crit: crit } }
      );
    }
  }

  slideInMenu(){
    //const leftMenu = document.getElementById("app-sidebar-1");
    //leftMenu.style.display = "block !important"
  }

  reset() {
    this.idle.watch();
    this.ShowTimeOut = false;
    this.countdown = null;
    this.lastPing = null;
  }

  backToVenues(){
    localStorage.removeItem("SmartVenueID");
    this.router.navigateByUrl("/business");
  }

  backToPin(){
    localStorage.removeItem('SmartUserName');
    this.currentUserName = '';
    this.globalService.setCurrentUserName('');
    let AccessControl = "";
    this.auth.getAccessTokenSilently({cacheMode: 'off'}).subscribe(token => {
      //this.busyService.busy();
      const parts = token.split('.');
      const decoded = JSON.parse(atob(parts[1]));
      let BusinessID = decoded["user.metadata"].businessid;
      let VenueID = decoded["user.metadata"].vid;

      localStorage.setItem("SmartVenueID", VenueID);

        AccessControl  = decoded["user.metadata"].accesscontrol;
        let userid = decoded["user.metadata"].businessuserid;
        let venuename = decoded["user.metadata"].venuename;
        let businessid = decoded["user.metadata"].businessid;
        let multivenueuser = decoded["user.metadata"].multivenueuser;
        let businessuserid = decoded["user.metadata"].businessuserid;

        localStorage.setItem("SmartUserID", userid);
        localStorage.setItem("SmartBusinessID", businessid);

        //Same guard as the login path above. Without it, going back to the PIN pad wrote the
        //placeholder over the venue that was chosen on the way in, and every screen after it
        //welcomed the user to "Not Assigned".
        if (this.globalService.isRealVenueName(venuename)) {
          localStorage.setItem("SmartVenueName", venuename);
        }

        // let users: user[] =  (decoded["app.users"] as user[]);
        // let venues: businessVenue[] = (decoded["app.venues"] as businessVenue[]);

        let businessowner = decoded["user.metadata"].businessowner;
        if(businessowner == "true")
        {
          localStorage.setItem("businessowner", "TRUE");
          this.businessOwner = true;
        }
        else
        {
          localStorage.setItem("businessowner", "FALSE");
          this.businessOwner = false;
        }

      this.http.get<any>(bmxurl + "business/" + businessid + '/' + businessuserid + '/' + VenueID + '/' + businessowner ).subscribe(response => {

          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            let users: user[] =  (this.httpResponse.data.users as user[]);
            let venues: businessVenue[] = (this.httpResponse.data.venues as businessVenue[]);

            if(multivenueuser == "true")
            {
              localStorage.setItem("SmartMultiVenueUser", "TRUE");
              this.multiVenueUser = true;
            }
            else
            {
              localStorage.setItem("SmartMultiVenueUser", "FALSE");
              this.multiVenueUser = false;
            }
            
            localStorage.setItem("SmartBusinessVenues", JSON.stringify(venues ?? []));
            localStorage.setItem("SmartUsers", JSON.stringify(users ?? []));
            this.resolveCurrentUserName();

            if((BusinessID != null || BusinessID != "") && VenueID == null)
            {

              if(this.businessOwner)
              {
                this.logEntry("Business Owner so create menu");

                localStorage.setItem("SmartBusinessID", BusinessID);
                this.items = [{
                  label: 'BUSINESS',
                  items: [
                    {label: 'Business', icon: 'pi globe', routerLink: ['/business'], visible: true},
                    ]
                }];
                this.router.navigateByUrl("/business");

              // this.globalService.setMenuItems(this.items);
              }
              else
              {

                this.logEntry("Non-Business Owner so go to pinpad");

                localStorage.setItem("SmartBusinessID", BusinessID);
                this.items = [{
                  label: '',
                  items: [
                  
                    ]
                }];

                this.globalService.setMenuItems(this.items);

                this.router.navigateByUrl("pinpad");
              }

            }
            else
              {

                localStorage.setItem("SmartBusinessID", BusinessID);
                this.items = [{
                  label: '',
                  items: []
                }];

                this.globalService.setMenuItems(this.items);

                this.router.navigateByUrl("pinpad");
            }

            this.auth.isAuthenticated$.subscribe((authed) => {
              if(authed)
              {
                this.router.navigateByUrl("/pinpad");
              }
            });
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to businesses'});
          })
      
      //this.busyService.idle();
      
    }),
    error => {
      //this.busyService.idle();
    };

  }

  ngOnDestroy(): void {
    this.kitchenChannel.close();
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  manageUserPassword(){
    this.showPasswordChange = true;
  }

  doPINChange(){
    if(this.NewPIN == this.RepeatNewPIN)
    {
      let pinChange: pinchange = {
        oldpin: this.OldPIN,
        newpin: this.NewPIN
      }

      this.http.post<pinchange_returndata>(bmxurl + "/PinChange", pinChange).subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded == true)
        {
          this.messageService.add({severity:'success', summary:'Success', detail:'Your PIN has been changed.'});

          this.RepeatNewPIN = "";
          this.OldPIN = "";
          this.NewPIN = "";

          this.showPasswordChange = false;

          this.router.navigateByUrl("/homepagechoice");
        }
        else{
          this.messageService.add({severity:'error', summary:'Error', detail:this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:error.messages[0]});
      })
    }
    else
    {
      this.PasswordsMatch = false;
    }
  }



}
